import {
  ADMIN_MARKET_COUNTRIES,
  currencyForAdminCountry,
} from "../../common/adminMarketCountries";

/** @deprecated use ADMIN_MARKET_COUNTRIES */
export const ADMIN_PLAN_PRICING_COUNTRIES = ADMIN_MARKET_COUNTRIES;

export type AdminPlanPricingCountryCode =
  (typeof ADMIN_PLAN_PRICING_COUNTRIES)[number]["code"];

export { currencyForAdminCountry };
